export enum LocalStorageKeys {
  AUTH = 'auth',
  SAVED_LOGIN = 'savedLogin',
  REMEMBER_CHECKBOX = 'rememberCheckbox',
  HAS_SEEN = 'hasSeenOnboarding',
  STAFF_ID = 'staffId',
  TWO_FACTOR_STATUS_KEY = '2FAStatus',
  EMAIL = 'email',
  USER = 'user',
}
